import { render } from "./PortfolioDropdown.vue?vue&type=template&id=06045996&scoped=true"
import script from "./PortfolioDropdown.vue?vue&type=script&lang=js"
export * from "./PortfolioDropdown.vue?vue&type=script&lang=js"

import "./PortfolioDropdown.vue?vue&type=style&index=0&id=06045996&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06045996"]])

export default __exports__